import { Axios } from '@/utils/axios';
import { ModelEmsPayload } from '@/models/outbounds';

export class outboundAPI extends Axios {
  constructor() {
    super();
  }

  public async outboundEms(payload: ModelEmsPayload) {
    try {
      const { data } = await this.axios.post('outbound/ems', payload);
      return data;
    } catch (e) {
      throw e;
    }
  }
  public async outboundDhl(payload: ModelEmsPayload) {
    try {
      const { data } = await this.axios.post('outbound/dhl', payload);
      return data;
    } catch (e) {
      throw e;
    }
  }
}
